import React, { useState } from "react";
import { useContent } from "@/context/ContentContext";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";

export default function Portfolio() {
  const { content } = useContent();
  const projects = content?.projects || [];
  const cats = ["All", ...Array.from(new Set(projects.map((p) => p.category).filter(Boolean)))];
  const [filter, setFilter] = useState("All");
  const shown = filter === "All" ? projects : projects.filter((p) => p.category === filter);

  return (
    <div data-testid="portfolio-page" className="bg-[#050505]">
      <PageHeader eyebrow="Selected Work" title="Work we're proud to put our name on." />
      <section className="bg-[#050505] text-white pb-28 px-6 md:px-12 lg:px-16">
        <div className="max-w-[1400px] mx-auto">
          <div className="flex flex-wrap gap-3 mb-14">
            {cats.map((c) => (
              <button
                key={c}
                data-testid={`filter-${c.toLowerCase().replace(/\s/g, "-")}`}
                onClick={() => setFilter(c)}
                className={`px-5 py-2 text-sm font-medium border transition-colors ${
                  filter === c ? "bg-[#D4FF00] text-black border-[#D4FF00]" : "border-white/25 text-white hover:border-white"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {shown.map((p, i) => (
              <Reveal key={p.id} delay={i * 0.05}>
                <div data-testid={`portfolio-item-${i}`} className={`group ${i % 2 === 1 ? "md:mt-20" : ""}`}>
                  <div className="overflow-hidden aspect-[4/3] bg-zinc-900">
                    <img src={p.image} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  </div>
                  <div className="mt-5">
                    <h3 className="font-display text-3xl tracking-tight">{p.title}</h3>
                    <p className="font-mono-t text-xs uppercase tracking-widest text-zinc-500 mt-2">{p.category} — {p.year}</p>
                    <p className="text-zinc-400 mt-3 leading-relaxed max-w-lg">{p.description}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
